module.exports = __webpack_public_path__ + "static/2HOVER-34d46ad97b2b2b8d35209cd339e0fc04.png";